import { download } from '@/api/core'

/**
 * 图形验证码程序，提供一个r参数必须要长度大于15的随机数,
 * @description https://api.yinnho.cn/api.php?do=member_captcha&help
 *
 * @param r 长度大于15的随机数
 */
export function member_captcha (r: string) {
  return download('member_captcha', { r }, {
    autoSave: false,
  })
}
